import React, { useState, useEffect } from "react";
import { axiosReq, axiosReq2 } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { MainAdminTables, AddModalWriters, DeleteModalWriters } from "../../components"
import AddModalAdmin from "../../components/MainAdmin/Modals/AddModalAdmin";
import SettingModal from "../../components/MainAdmin/Modals/SettingModal";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
import {useLocation } from "react-router-dom"; 
import AddModalRagAccess from "../../components/MainAdmin/Modals/AddModalRagAccess";
import DeleteModalUserAccess from "../../components/MainAdmin/Modals/DeleteModalUserAccess";

const MainAdminAccessUsers = () => {


    const titleRow = ["نام"];
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showSettingModal, setShowSettingModal] = useState(false);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [writersList, setWritersList] = useState([]);
    const [data, setData] = useState();
    const [rags, setRags] = useState();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
        const location = useLocation();
    console.log(location)
    const itemsPerPage = 10;
      let navigate = useNavigate();

       const GetData = async () => {
            const writersData = await axiosReq2("admin/rag_access/rag_systems?user_id="+location?.state?.id, "get");
            console.log(writersData)
        
              setWritersList(writersData)
            //  setCount(writersData?.count)

                         const rag = await axiosReq2("admin/rag_system", "get");
                         console.log(rag)
                      
                           setRags(rag)
                  
        }
          const auth = async () => {
                        const cookies = new Cookies();
                        var token = cookies.get('token');
                        console.log(token)
                        console.log(cookies.get('role'))
                        if (!token) {
                            navigate("/");
                        } 
                        else {
                        //     if( cookies.get('role')=="Admin")
                        //    {
                
                               GetData()
                        //    }
                
                            
                        //     else {
                        //         navigate("/admin");
                
                        //     }
                        }
                    }
        useEffect(() => {
    
            auth();
        }, [reCheck,search,page, row,]);

   
    // const currentItems = writersList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div>
            <div className="p-[20px] flex justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={'black'} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">دسترسی ها</p>
                </div>
                <div className="flex justify-start items-center">
                    {/* <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e)=>setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button><Search /></button>
                    </div> */}
                    {/* <button className="w-[121px] h-[40px] hoverBgYellow bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <div><Report /></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </button> */}
                    <button onClick={() => setShowAddModal(true)} className="w-[154px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <p className="font-IRANYekanLight text-[28px] text-white">+</p>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن دسترسی</p>
                    </button>
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px]">
                <MainAdminTables detail={false} edit={false} block={false} deleted={true} setting={false}
                    setShowEditModal={setShowEditModal} setShowBlockModal={setShowBlockModal} 
                    setShowDeleteModal={setShowDeleteModal}
                    data={data} setData={setData}
                    setShowSettingModal={setShowSettingModal}
                    titleRow={titleRow} writersList={writersList} 
                    count={count} page={page} setPage={setPage} row={row} setRow={setRow} /></div>


            {showAddModal ? <AddModalRagAccess title={'افزودن دسترسی'} buttonName={'ثبت'} setShowModal={setShowAddModal} 
            reCheck={reCheck} setRecheck={setRecheck} setSettingModal={setShowSettingModal} data={rags} id={location?.state?.id} /> : null}
            {/* {showEditModal ? <AddModalAdmin title={'ویرایش'} buttonName={'ویرایش'} setShowModal={setShowEditModal} data={data} reCheck={reCheck} setRecheck={setRecheck} /> : null} */}
            {showDeleteModal ? <DeleteModalUserAccess title={'حذف دسترسی'} buttonName={'حذف'}id={location?.state?.id}
             text={'آیا از حذف دسترسی انتخاب شده اطمینان دارید ؟'} setShowModal={setShowDeleteModal} data={data} reCheck={reCheck} setRecheck={setRecheck} /> : null}
            {/* {showSettingModal ? <SettingModal title={'مدیریت دسترسی'} buttonName={'ثبت'} setShowModal={setShowSettingModal} reCheck={reCheck} setRecheck={setRecheck} data={data} /> : null} */}
           
        </div>
    )
}

export default MainAdminAccessUsers;